/* eslint react/jsx-props-no-spreading: 0 */ // --> OFF

import React from "react";
import { FileUpload } from "primereact/fileupload";

export default function FileUploadPR({ children, ...props }) {
  return <FileUpload {...props}>{children}</FileUpload>;
}
